"use strict";

const urls = {
    FACEBOOK_URL: 'https://www.facebook.com/loudupofficial',
    TWITTER_URL: 'https://www.twitter.com/loudupofficial',
    YOUTUBE_URL: 'https://www.youtube.com/channel/UCVwTwDBWDs1u8aKXJG2Ywtw',
    SOUNDCLOUD_URL: 'https://soundcloud.com/loudupofficial',
    PINTEREST_URL: 'https://www.pinterest.com/loudupofficial',
    API_URL: 'api/v1.0',// process.env.NODE_ENV === 'production' ? 'https://www.loudup.com/api/v1.0' : 'http://localhost:7076/api/v1.0',
    //USER_IMAGES_BASE_URL: process.env.NODE_ENV === 'production' ? 'https://www.loudup.com' : 'http://localhost:81'
    USER_IMAGES_BASE_URL: ''
};

export default urls;